import { Outlet, useLocation } from 'react-router-dom';
import { SubHeader } from '../Account/SubHeader';
import './Group.scss';
import bgBottom from '../../images/account/bg-1.svg';
import { BgTop } from '../../images/account/AccountBgTop';

export const Group = () => {
  const { state } = useLocation();
  const accountId = state?.accountId;
  return (
    <div className="group-container account-container">
      <SubHeader />
      <div
        className="image-layer"
        style={{ display: accountId ? 'block' : 'none' }}
      >
        <img src={bgBottom} alt="Background Base" className="bg-image base" />
        <BgTop />
      </div>
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};
